import { StyleSheet } from 'react-native';
import theme from '../../common/theme';
import { ThemeColors } from '../../common/theme-colors';

export const getStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      width: 50,
      height: 50,
      alignItems: 'center',
      justifyContent: 'center',
      borderWidth: 1,
      borderRadius: theme.radius.m,
      backgroundColor: colors.elevation0,
      borderColor: colors.borderMuted,
      overflow: 'hidden',
    },
    primary: {
      backgroundColor: colors.primary,
      borderColor: colors.primary,
    },
    pressed: {
      transform: [{ scale: 0.95 }],
    },
    // eslint-disable-next-line react-native/no-color-literals
    disabled: {
      opacity: 0.3,
      borderColor: 'transparent',
    },
  });
